import React, { useEffect, useState } from 'react';
import DirectoryCard from "./DirectoryCard.js";
import { getFirestore, collection, getDocs } from "firebase/firestore";
import { Grid } from "theme-ui";
import SidePanel from './SidePanel.js';
import defaultPicture from './images/default.png';
import DirectoryStacked from './DirectoryStacked.js';

const Directory = () => {

    const [users, setUsers] = useState([]);
    const [popup, setPopup] = useState("");
    const [panel, setPanel] = useState(null);
    const [isPanel, setIsPanel] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [viewMode, setViewMode] = useState('cards'); // 'cards' or 'bars'

    console.log(1);
    const db = getFirestore();
    console.log(2);

    const getUsers = async () => {
        const querySnapshot = await getDocs(collection(db, "users"));
        const userData = [];
        querySnapshot.forEach(doc => {
            userData.push({
                id: doc.id,
                ...doc.data()
            });
        });
        setUsers(userData);
    }

    useEffect(() => {
        getUsers();
    }, []);

    const normalizeArrayField = (field) => {
        return Array.isArray(field) 
          ? field.map(item => item.toLowerCase()).join(', ') 
          : (field || '').toLowerCase();
    };
      
    const filteredUsers = users
        .filter(user => 
          user.displayName.toLowerCase().includes(searchQuery.toLowerCase()) ||
          normalizeArrayField(user.concentration).includes(searchQuery.toLowerCase()) ||
          normalizeArrayField(user.interests).includes(searchQuery.toLowerCase())
        )
        .sort((a, b) => a.displayName.localeCompare(b.displayName));      
    
    const openPanel = (user) => {
        setIsPanel(true);
        setPanel(user);
    };

    const closePanel = () => {
        setIsPanel(false);
        setPanel(null);
    };

    return (
        <div style={{ width: '100%', display: 'flex', color: '#F9F9F9', justifyItems: 'center' }}>
    
            <div style={{ 
                padding: '5%', 
                width: isPanel ? '80%' : '100%',
                transition: 'width 0.3s ease'
            }}>
                {/* search bar and view toggle */}
                <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', alignItems: 'center' }}>
                    <input
                        type="text"
                        placeholder="Search by name, concentration, or interest..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{ 
                            flex: 1,
                            padding: '15px', 
                            border: '1px solid #6E4884', 
                            borderRadius: '20px', 
                            color: 'grey', 
                            boxShadow: '0px 0px 4px rgba(128, 128, 128, 0.5)',
                            fontFamily: "Poppins",
                        }}
                    />
                    
                    {/* view toggle buttons */}
                    <div style={{ display: 'flex', gap: '5px', background: '#2a2a2a', borderRadius: '20px', padding: '5px' }}>
                        <button
                            onClick={() => setViewMode('cards')}
                            style={{
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: '15px',
                                background: viewMode === 'cards' ? '#6E4884' : 'transparent',
                                color: '#F9F9F9',
                                cursor: 'pointer',
                                fontFamily: 'Poppins',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            Cards
                        </button>
                        <button
                            onClick={() => setViewMode('bars')}
                            style={{
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: '15px',
                                background: viewMode === 'bars' ? '#6E4884' : 'transparent',
                                color: '#F9F9F9',
                                cursor: 'pointer',
                                fontFamily: 'Poppins',
                                transition: 'all 0.3s ease',
                            }}
                        >
                            Bars
                        </button>
                    </div>
                </div>
    
                {/* rendering based on view mode */}
                {viewMode === 'cards' ? (
                    <Grid
                        sx={{
                        flex: '1',
                        maxWidth: '100%',
                        gridTemplateColumns: [
                            '2fr',
                            isPanel ? 'repeat(3, minmax(200px, 1fr))' : 'repeat(4, minmax(200px, 1fr))',
                        ],
                        margin: '0 auto',
                        gap: '20px',
                        padding: '20px 30px',
                        justifyContent: 'center',
                        transition: 'all 0.3s ease',

                        '@media (max-width: calc(768px - 150px))': {
                            gridTemplateColumns: '2fr',
                        },
                        '@media (max-width: calc(1024px - 150px))': {
                            gridTemplateColumns: isPanel ? '2fr' : 'repeat(3, minmax(200px, 1fr))',
                        },
                        }}
                    >
                        {filteredUsers.map(user => (
                            <DirectoryCard
                                key={user.id}
                                displayName={user.displayName}
                                email={user.email}
                                linkedin={user.linkedin}
                                instagram={user.instagram}
                                role={user.role}
                                classYear={user.classYear}
                                concentration={user.concentration}
                                photo={user.photoURL}
                                bio={user.bio}
                                companies={user.companies}
                                interests={user.interests}
                                courses={user.courses}
                                openPanel={openPanel} 
                                setErrorMessage={setErrorMessage}
                            />
                        ))}
                    </Grid>
                ) : (

                <div style={{ padding: '20px 30px' }}>
                    {filteredUsers.map(user => (
                        <DirectoryStacked
                            key={user.id}
                            displayName={user.displayName}
                            email={user.email}
                            linkedin={user.linkedin}
                            instagram={user.instagram}
                            role={user.role}
                            classYear={user.classYear}
                            concentration={user.concentration}
                            photo={user.photoURL}
                            bio={user.bio}
                            companies={user.companies}
                            interests={user.interests}
                            courses={user.courses}
                            coursesTaught={user.coursesTaught}
                            openPanel={openPanel} 
                            setErrorMessage={setErrorMessage}
                        />
                    ))}
                </div>
                )}
            </div>
    
            {isPanel && (
                <div style={{
                    width: '300px', 
                    transition: 'width 0.3s ease'
                }}>
                    <SidePanel user={panel} closePanel={closePanel} />
                </div>
            )}
        </div>
    );

}

export default Directory;